import React from "react";
import { FigureHorStackBarKpiProviders, FigureKpiProviders } from "../categoryChartQueryFns";
import { Paragraph } from "../Paragraph";
import { useCategoryContext } from "../Context";
import { CategoryChart } from "../../Components/processors";

type DisplayTitleProps = {
    categoryChart: CategoryChart;
} & (FigureKpiProviders | FigureHorStackBarKpiProviders | FigureHorStackBarKpiProviders);

export const DisplayTitle: React.FC<DisplayTitleProps> = ({ title, footer }) => {
    const { category } = useCategoryContext();

    if (!category) return null;

    return (
        <>
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="" />}
            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="" />}
        </>
    );
};
